import type {DurationFormat} from '../types';
import type {Dispatch, SetStateAction} from 'react';

import {useCountdown} from '../hooks/useCountdown';
import {formatSeconds} from '../utils/formatDuration';

export type CountdownTimerProps = {
  initialCounter: number;
  setCountDown?: Dispatch<SetStateAction<number>>;
  format?: DurationFormat;
  className?: string;
  onExpire?: () => void;
};

export function CountdownTimer({
  initialCounter,
  setCountDown,
  format = 'mm:ss',
  className,
  onExpire
}: CountdownTimerProps) {
  const {remaining} = useCountdown({
    initialSeconds: initialCounter,
    autoStart: initialCounter > 0,
    onExpire: () => {
      setCountDown?.(0);
      onExpire?.();
    }
  });

  return (
    <p className={className ?? 'text-sm font-medium tabular-nums text-gray-08'} dir="ltr">
      {formatSeconds(remaining, format)}
    </p>
  );
}

export function CountdownDisplay({
  remaining,
  format = 'mm:ss',
  className
}: {
  remaining: number;
  format?: DurationFormat;
  className?: string;
}) {
  return (
    <span className={className ?? 'tabular-nums'} dir="ltr">
      {formatSeconds(remaining, format)}
    </span>
  );
}
